<svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
  <path
    d="M26.25 0C11.6012 0.903344 0 13.07 0 27.9462C0 42.8224 11.6012 54.9891 26.25 55.8924V0Z"
    fill="#30747F"
  />
  <path
    d="M55.9462 26.1962C55.0786 12.1262 43.82 0.867654 29.75 0V26.1962H55.9462Z"
    fill="#FB946E"
  />
  <rect
    x="46.75"
    y="29.696"
    width="17"
    height="17"
    transform="rotate(90 46.75 29.696)"
    fill="#FFC200"
  />
</svg>
